export default "__VITE_ASSET__A_uMtbcr__"